// extracted by mini-css-extract-plugin
export default {"backgroundColorOverride":"LoginContainer_backgroundColorOverride__51OEy","container":"LoginContainer_container__SL9nL"};